import React, { useState, useEffect } from 'react';
import { Link, Redirect } from 'react-router-dom';

import { useIdleTimer } from 'react-idle-timer';
import { useSelector, useDispatch } from 'react-redux';
import * as authActions from '~/store/modules/auth/actions';
import history from '~/services/history';

import { NavBar } from '~/components/NavBar';
import logo from '~/assets/logo.svg';
import {
  Container,
  Content,
  BoxNavBar,
  Left,
  Right,
  BoxSearch,
} from './styles';

const Header = props => {
  const [search, setSearch] = useState('');
  const { signed, systemConfig } = useSelector(state => state.auth);
  const dispatch = useDispatch();

  const { pathname } = window.location;

  useEffect(() => {
    if (signed && !systemConfig?.usuarioAssinouTermo) {
      history.push('/aceitar-termo');
    }
  }, [systemConfig, pathname]);

  const handleOnIdle = () => {
    if (signed) {
      dispatch(authActions.revokeTokenRequest());
      dispatch(authActions.signOut());
    }
  };

  // 30 minutos sem atividade do usuário chama função de logout
  useIdleTimer({
    timeout: 1000 * 60 * 30,
    onIdle: handleOnIdle,
    debounce: 500,
  });

  return (
    <>
      <Container>
        <Content>
          <Left>
            <Link to="/indicadores-gerais">
              <img src={logo} alt="SIHOSP" />
            </Link>
          </Left>

          <Right>
            <nav>
              <span>DISQUE ANS 0800 7019656</span>
              <ul>
                <li>
                  <a
                    href="http://www.ans.gov.br/canais-de-atendimento"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="CANAIS DE ATENDIMENTO"
                  >
                    CANAIS DE ATENDIMENTO
                  </a>
                  <a
                    href="https://sistema.ouvidorias.gov.br/publico/Manifestacao/SelecionarTipoManifestacao.aspx"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Fale sobre a ANS"
                  >
                    Fale sobre a ANS
                  </a>
                  <a
                    href="http://www.ans.gov.br/comunicacao-e-imprensa"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Comunicação e Imprensa"
                  >
                    Comunicação e Imprensa
                  </a>
                </li>
              </ul>
            </nav>

            <BoxSearch>
              <form
                action={`http://www.ans.gov.br/resultado-da-busca?q=${search}&f=1`}
                method="POST"
                target="_blank"
              >
                <input
                  type="text"
                  placeholder="Buscar no sítio da ANS"
                  value={search}
                  onChange={e => setSearch(e.target.value)}
                />
                <button type="submit">Buscar</button>
              </form>
            </BoxSearch>
          </Right>
        </Content>
        <BoxNavBar id="conteudo">
          {signed ? (
            <NavBar props={props} />
          ) : (
            <p className="title">SISTEMA DE INDICADORES HOSPITALARES</p>
          )}
        </BoxNavBar>
      </Container>
    </>
  );
};

export default Header;
